import React, { useState } from 'react';
import { Box, Button, Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import classes from './SetupRecs.module.scss';
import OnboardingWelcome from './OnboardingWelcome';
import OnboardingPage from './OnboardingPage';
import OnboardingPageExplainProcess from './OnboardingPageExplainProcess';
import OnboardingIndustry from './OnboardingIndustry';
import OnboardingPageSupport from './OnboardingPageSupport';
import {
  onboardingRecsChange,
  onboardingRecsWizardComplete,
} from '../../slices/OnboardingSlice';
import { toggleValueInArray } from '../../util/appUtils';
import IntlMessages from 'util/IntlMessages';

export default function SetupVisualRecs() {
  const [page, changePage] = useState(0);
  const store = useSelector((s) => s);
  const { industries } = store.onboarding.recs;
  const dispatch = useDispatch();
  const changeIndustries = (value) => {
    const copy = [...industries];
    dispatch(onboardingRecsChange({ industries: toggleValueInArray(value, copy) }));
  };

  const completeWizard = () => {
    dispatch(onboardingRecsWizardComplete());
  };

  const pages = [
    <OnboardingWelcome className={classes.page} />,
    <OnboardingPageExplainProcess className={classes.page} />,
    <OnboardingPage className={classes.page} />,
    <OnboardingIndustry onClick={changeIndustries} className={classes.page} />,
    <OnboardingPageSupport className={classes.page} />,
  ];

  const prevButton = (page === 0
    && <Button variant="contained" onClick={completeWizard}><IntlMessages id="ui.setupVisualRecs.setupVisualRecs.skipWizard" /></Button>)
    || <Button variant="contained" onClick={() => changePage(page - 1)}><IntlMessages id="appModule.back" /></Button>;

  const nextButton = (page === (pages.length - 1)
    && <Button variant="contained" color="primary" onClick={completeWizard}><IntlMessages id="wizard.button.finish" /></Button>)
    || <Button variant="contained" color="primary" onClick={() => changePage(page + 1)}><IntlMessages id="appModule.next" /></Button>;

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Box px={3} py={10} textAlign="center">
        {pages[page]}
      </Box>
      <Box position="absolute" bottom={10} width="80%">
        <Box py={2}>
          <Grid container justifyContent="space-between">
            <Grid item>
              {prevButton}
            </Grid>
            <Grid item>
              {nextButton}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Grid>
  );
}
